import { DefaultFormFields, MajorityRequest, RequestCoverageForm, RequestExclusionForm } from "./majority-types";
import moment from "moment";

const competenceMonth = parseInt(moment().format('MM'));
const competenceYear = parseInt(moment().format('YYYY'));

export const defaultFilter = (): MajorityRequest => ({
  carrierId: null,
  competenceMonth: competenceMonth,
  competenceYear: competenceYear,
  contractId: null,
  coverageExtensionReason: null,
  externalProtocol: null,
  financialGroupId: null,
  cpf: null,
  name: null,
  majorityStatus: null,
  monthsAdvance: [],
  subContractId: null,
  page: 0,
  size: 25,
  sort: 'updatedAt,desc',
});

export const defaultCoverageForm = (): RequestCoverageForm => ({
  comment: null,
  coverageExtensionLimitDate: null,
  coverageExtensionReason: null,
  documents: [],
  isCoverageLimitIndefinite: false
});

export const defaultExclusionForm = (): RequestExclusionForm => ({
  comment: null,
  documents: [],
  endDate: null,
  exclusionReasonCode: 'Idade Limite',
});

export const defaultRequestForm = (): DefaultFormFields => ({
  comment: null,
  documents: [],
});